"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DailyScheduleHarmonizationManager = void 0;
const core_1 = require("../../core");
const helpers_1 = require("../../helpers");
const constants_1 = require("./constants");
const helpers_2 = require("./helpers");
require("./models");
const ScheduleHarmonizationManager_1 = require("./ScheduleHarmonizationManager");
const types_1 = require("./types");
class DailyScheduleHarmonizationManager extends ScheduleHarmonizationManager_1.ScheduleHarmonizationManager {
    constructor(mainModel, controlModel, models, retentionFieldsSettings) {
        super(Object.assign(Object.assign({}, models), { dailyScheduleModel: mainModel }));
        this.mainModel = mainModel;
        this.controlModel = controlModel;
        this.models = models;
        this.retentionFieldsSettings = retentionFieldsSettings;
        this.getCurrentState = () => {
            return DailyScheduleHarmonizationManager.getCurrentStateData(this.mainModel.getValue());
        };
        this.getAvailableOptions = () => {
            return this.getCurrentState();
        };
        this.harmonize = (shouldResetSchedule = true) => {
            const modelValue = this.mainModel.getValue();
            // reset
            if (shouldResetSchedule && !modelValue.isEnabled && modelValue.isModified) {
                return DailyScheduleHarmonizationManager.getMainModelInitialValue(modelValue.rows.first.isEnabled, modelValue.rows.second.isEnabled, modelValue.rows.third.isEnabled, modelValue.rows.first.fields.isTypeVisible, modelValue.rows.second.fields.isTypeVisible, modelValue.rows.third.fields.isTypeVisible, this.retentionFieldsSettings);
            }
            return modelValue;
        };
        this.mainModel = mainModel;
        this.controlModel = controlModel;
        this.scheduleModels = Object.assign(Object.assign({}, models), { dailyScheduleModel: mainModel });
        this.retentionFieldsSettings = retentionFieldsSettings;
    }
}
exports.DailyScheduleHarmonizationManager = DailyScheduleHarmonizationManager;
DailyScheduleHarmonizationManager.FIELD_KIND_INITIAL_VALUE = types_1.DAILY_SCHEDULE_KINDS.everyday;
DailyScheduleHarmonizationManager.RUNS_PER_HOUR_INITIAL_VALUE = 1;
DailyScheduleHarmonizationManager.getMainModelInitialValue = (isFirstRowScheduleVisible = true, isSecondRowScheduleVisible = true, isThirdRowScheduleVisible = true, isRowFirstFieldTypeVisible = false, isRowSecondFieldTypeVisible = false, isRowThirdFieldTypeVisible = true, retentionFieldsSettings) => {
    return {
        isEnabled: false,
        isModified: false,
        rows: {
            [types_1.SCHEDULE_ROW.first]: DailyScheduleHarmonizationManager.getRowFirstInitialValue(isFirstRowScheduleVisible, constants_1.HOURS_PER_DAY, retentionFieldsSettings.rowFirstFieldCountInitialValue, retentionFieldsSettings.rowFirstFieldTypeInitialValue, isRowFirstFieldTypeVisible),
            [types_1.SCHEDULE_ROW.second]: DailyScheduleHarmonizationManager.getRowSecondInitialValue(isSecondRowScheduleVisible, constants_1.HOURS_PER_DAY, retentionFieldsSettings.rowSecondFieldCountInitialValue, retentionFieldsSettings.rowSecondFieldTypeInitialValue, isRowSecondFieldTypeVisible),
            [types_1.SCHEDULE_ROW.third]: DailyScheduleHarmonizationManager.getRowThirdInitialValue(isThirdRowScheduleVisible, constants_1.HOURS_PER_DAY, retentionFieldsSettings.rowThirdFieldCountInitialValue, retentionFieldsSettings.rowThirdFieldTypeInitialValue, isRowThirdFieldTypeVisible),
        },
        fields: {
            kind: DailyScheduleHarmonizationManager.FIELD_KIND_INITIAL_VALUE,
            days: [],
        },
        runsPerHour: DailyScheduleHarmonizationManager.RUNS_PER_HOUR_INITIAL_VALUE,
    };
};
DailyScheduleHarmonizationManager.getWorkingDays = () => {
    return [
        core_1.DAY_OF_WEEK.monday,
        core_1.DAY_OF_WEEK.tuesday,
        core_1.DAY_OF_WEEK.wednesday,
        core_1.DAY_OF_WEEK.thursday,
        core_1.DAY_OF_WEEK.friday,
    ];
};
DailyScheduleHarmonizationManager.getDayOfWeekOptions = (dailyKind, selectedDays) => {
    if (dailyKind === types_1.DAILY_SCHEDULE_KINDS.everyday) {
        return helpers_2.getEverydayList();
    }
    if (dailyKind === types_1.DAILY_SCHEDULE_KINDS.weekDays) {
        return DailyScheduleHarmonizationManager.getWorkingDays();
    }
    return selectedDays;
};
DailyScheduleHarmonizationManager.getCurrentStateData = (modelValue) => {
    const defaultTimes = helpers_1.getTimes();
    const defaultDays = helpers_2.getEverydayList();
    const defaultMonths = helpers_2.getMonthsOfYearList();
    const defaultDayNumberInMonth = helpers_2.getDayNumberInMonthList();
    const dayOfWeek = modelValue.isEnabled
        ? DailyScheduleHarmonizationManager.getDayOfWeekOptions(modelValue.fields.kind, modelValue.fields.days)
        : defaultDays;
    const timeThirdRow = helpers_2.getFieldTimeData(modelValue.rows.third.schedule);
    return {
        time: {
            firstRow: modelValue.isEnabled
                ? helpers_2.getFieldTimeData(modelValue.rows.first.schedule)
                : defaultTimes,
            secondRow: modelValue.isEnabled
                ? helpers_2.getFieldTimeData(modelValue.rows.second.schedule)
                : defaultTimes,
            thirdRow: modelValue.isEnabled && timeThirdRow.length > 0 ? timeThirdRow : defaultTimes,
        },
        dayOfWeek: {
            firstRow: dayOfWeek,
            secondRow: dayOfWeek,
            thirdRow: dayOfWeek,
        },
        monthOfYear: {
            firstRow: defaultMonths,
            secondRow: defaultMonths,
            thirdRow: defaultMonths,
        },
        dayNumberInMonth: {
            firstRow: defaultDayNumberInMonth,
            secondRow: defaultDayNumberInMonth,
            thirdRow: defaultDayNumberInMonth,
        },
    };
};
DailyScheduleHarmonizationManager.getAvailableOptionsData = (modelValue) => {
    return DailyScheduleHarmonizationManager.getCurrentStateData(modelValue);
};
//# sourceMappingURL=DailyScheduleHarmonizationManager.js.map